import i18n from 'i18next'
import { DEFAULT_LANGUAGE } from 'constants/translations'

// EN - Directory-based imports
import commonEn from './locales/en/common.json'
import gameplayEn from './locales/en/gameplay.json'
import tutorialEn from './locales/en/tutorial.json'

// TR - Directory-based imports
import commonTr from './locales/tr/common.json'
import gameplayTr from './locales/tr/gameplay.json'
import tutorialTr from './locales/tr/tutorial.json'

// CN - Directory-based imports
import commonCn from './locales/cn/common.json'
import gameplayCn from './locales/cn/gameplay.json'
import tutorialCn from './locales/cn/tutorial.json'

// ES - Directory-based imports
import commonEs from './locales/es/common.json'
import gameplayEs from './locales/es/gameplay.json'
import tutorialEs from './locales/es/tutorial.json'

// KO - Directory-based imports
import commonKo from './locales/ko/common.json'
import gameplayKo from './locales/ko/gameplay.json'
import tutorialKo from './locales/ko/tutorial.json'

const options = {
  interpolation: {
    escapeValue: false
  },

  debug: false,

  resources: {
    en: {
      common: {
        ...commonEn,
        ...gameplayEn
      },
      tutorial: tutorialEn.tutorial
    },
    tr: {
      common: {
        ...commonTr,
        ...gameplayTr
      },
      tutorial: tutorialTr.tutorial
    },
    cn: {
      common: {
        ...commonCn,
        ...gameplayCn
      },
      tutorial: tutorialCn.tutorial
    },
    es: {
      common: {
        ...commonEs,
        ...gameplayEs
      },
      tutorial: tutorialEs.tutorial
    },
    ko: {
      common: {
        ...commonKo,
        ...gameplayKo
      },
      tutorial: tutorialKo.tutorial
    }
  },

  fallbackLng: DEFAULT_LANGUAGE,

  ns: ['common', 'tutorial'],

  defaultNS: 'common',

  react: {
    useSuspense: false,
    bindI18n: 'languageChanged loaded',
    bindStore: 'added removed',
    nsMode: 'default'
  }
}

const CustomLanguageDetector = {
  type: 'languageDetector',
  async: true,
  detect: (callback) => {
    callback(DEFAULT_LANGUAGE)
  },
  init: () => {},
  cacheUserLanguage: () => {}
}

i18n.use(CustomLanguageDetector).init(options)

export default i18n
